<template>
  <el-card class="dashboard-indicator clickable" shadow="hover">
    <div class="style-fullWidth" @click="click">
      <div slot="header" class="flex-row flex__center">
        {{ title }}
      </div>
      <div class="flex-row flex__center">
      <span
        class="font-weight__bold primary-indicator color__blue margin-right-5"
      >{{ indicator1 }}</span
      >
        <el-tag
          type="success"
          size="small"
          class="font-weight__bold"
          v-if="indicator2 != null"
        >
          {{ indicator2 }} mới
        </el-tag>
      </div>
    </div>
  </el-card>
</template>

<script>
  export default {
    name: "dashboard-indicator-template",
    props: ["indicator1", "indicator2", "title"],
    methods: {
      click(event) {
        this.$emit("click", event);
      }
    }
  };
</script>

<style scoped>
  .dashboard-indicator {
    width: 150px;
  }

  .primary-indicator {
    font-size: xx-large;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/dashboard-indicator-template.vue